import { LoadingStatusType } from "@/enums/enums";
import { ToContactList } from "@/helper/contactHelper";
import API from "@/service/index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Contact extends VuexModule {
  public contactList: any = [];
  public contactListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  @Mutation
  MutationContactList(contactList: any) {
    this.contactList = contactList;
  }

  @Mutation
  MutationSetContactListLoadingStatus(status: LoadingStatusType) {
    this.contactListLoadingStatus = status;
  }

  @Action
  public DoGetAllContact(isUseMainDatabase = false) {
    if (this.contactListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit(
        "MutationSetContactListLoadingStatus",
        LoadingStatusType.Loading
      );
      API.ContactService.DoGetAllContact(isUseMainDatabase)
        .then(res => {
          const contactList = ToContactList(res.data.contactList);
          this.context.commit("MutationContactList", contactList);
          this.context.commit(
            "MutationSetContactListLoadingStatus",
            LoadingStatusType.Success
          );
        })
        .catch(error => error);
    }
  }
}
